import { useState, useEffect } from 'react';
import { fetchCollaborationContent } from './collaborationApi';
import { CollaborationData } from './types';

export const useGetCollaborationContent = () => {
  const [collaborationData, setCollaborationData] =
    useState<CollaborationData | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadContent = async () => {
      try {
        setIsLoading(true);
        setError(null);
        const response = await fetchCollaborationContent();

        if (response.status === 200) {
          setCollaborationData(response.data);
        } else {
          setError('Failed to load collaboration content');
        }
      } catch (err) {
        setError('Error loading collaboration content');
        console.error('Collaboration content loading error:', err);
      } finally {
        setIsLoading(false);
      }
    };

    loadContent();
  }, []);

  return { collaborationData, isLoading, error };
};
